export default {
  methods: {
    roundName(list, i) {
      const round = list[i];
      return this.$t(
        '_web_tournaments-swiss_round-basic-name',
        'Round {number}',
        { number: +round.index + 1 }
      );
    },
  },
};
